import HeaderNavLink from "./HeaderNavLink";

export default HeaderNavLink;
